export const AUTHORIZATION = 'Авторизация';
export const LOGIN = 'Введите логин';
export const PASSWORD = 'Введите пароль';
export const SUBMIT = 'Войти';
export const FORGET_PASSWORD = 'Забыли пароль?';
export const AUTHORIZATION_PROBLEM = 'Проблемы с авторизацией?';
export const ADMINISTRATOR = 'Обратитесь к администратору ';
export const EMAIL = 'edu@fond-igra.ru';
export const PASSWORD_RECOVERY = 'Восстановление пароля';
export const RECOVERY_LINK = 'Мы отправим Вам на почту ссылку для восстановления пароля';
export const EMAIL_RECOVERY = 'Введите почту';
export const SEND_LINK_RECOVERY = 'Получить ссылку на восстановление';
export const PASSWORD_PROBLEM = 'Проблемы с восстановлением пароля?';
export const CONFIRMATION_PASSWORD = 'Подтвердите пароль';
export const NEW_PASSWORD = 'Придумайте новый пароль';
export const SAVE_NEW_PASSWORD = 'Сохранить новый пароль';
export const SUCCESS_AUTH = 'Вы успешно авторизованы!';
export const SUCCESS_RESET_PASS = 'Пароль учетной записи успешно изменен!';
